import { Link as TanStackLink } from '@tanstack/react-router';
import { styled } from 'styletron-react';
const styles = {
    textDecoration: 'none',
};
export const Link = styled(TanStackLink, styles);
export const BasicLink = styled('a', styles);
